import styled from 'styled-components';

/* Institutional footer. Colours mirror the tokens in src/styles/global.css. */

export const Box = styled.footer`
  background: #0e2748;
  color: #ffffff;
  width: 100%;
  border-top: 4px solid #c8a02a;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  grid-gap: 48px;
  padding: 64px 0 48px;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 40px;
    padding: 48px 0 32px;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    grid-gap: 32px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const Heading = styled.h2`
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 0.75rem;
  color: #ffffff;
  margin: 0 0 20px 0;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
`;

export const FooterLink = styled.a`
  color: #c7d4e4;
  margin-bottom: 12px;
  font-size: 0.875rem;
  text-decoration: none;
  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

export const BrandSection = styled.div`
  img {
    filter: brightness(0) invert(1);
    margin-bottom: 20px;
    height: 56px;
    width: auto;
  }

  p {
    color: #c7d4e4;
    font-size: 0.875rem;
    line-height: 1.7;
    margin: 0 0 20px 0;
    max-width: 38ch;
  }
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #c7d4e4;
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 14px;

  a {
    color: #c7d4e4;
    text-decoration: none;

    &:hover {
      color: #ffffff;
      text-decoration: underline;
    }
  }

  svg {
    font-size: 18px;
    color: #c8a02a;
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export const SocialRow = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 8px;
`;

export const SocialLink = styled.a`
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.24);
  color: #ffffff;
  transition: background 0.2s ease, border-color 0.2s ease;

  &:hover {
    background: #225491;
    border-color: #225491;
  }

  svg {
    font-size: 18px;
  }
`;

export const LegalBar = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 24px 0;
`;

export const LegalInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const LegalLinks = styled.nav`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  a {
    color: #9fb2c8;
    font-size: 0.8125rem;
    text-decoration: none;

    &:hover {
      color: #ffffff;
      text-decoration: underline;
    }
  }
`;

export const DevelopmentLink = styled.p`
  font-size: 0.8125rem;
  color: #9fb2c8;
  line-height: 1.7;
  margin: 0;

  span {
    color: #c7d4e4;
    font-weight: 600;
  }
`;
